// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    hideLoadingOverlay,
    xngLoadingOverlayUtilitiesStyles,
} from "@guestsupply/App/Components/Common/XngLoadingOverlayUtilities";
import { mobileTippyStyle } from "@guestsupply/App/Components/Tippy/Style";
import { createAccountStyles } from "@guestsupply/App/SharedStyles/classicStyles";
import { xBaseTheme } from "@guestsupply/XDL/types";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

export default {
    css: css`
        ${mobileTippyStyle}
        ${createAccountStyles}
        ${xngLoadingOverlayUtilitiesStyles}
        ${hideLoadingOverlay}
        [data-tippy-root] {
            z-index: ${getProp("theme.zIndex.tippy")} !important;
        }
    `,
} as xBaseTheme["globalStyle"];
